<template>
  <div>
    <CTabs
      :vertical="vertical"
      :variant="variant"
      add-nav-wrapper-classes="website-tabs"
      @update:activeTab="handleActiveTab"
    >
      <!-- Cookies -->
      <CTab>
        <template slot="title"> Cookies </template>

        <CRow class="my-4 justify-content-between">
          <CCol col="12" lg="8" xl="8">
            <!-- Enable alert  -->
            <CRow class="mb-5">
              <CCol col="12">
                <h5>
                  <b>Configurações</b>
                </h5>
              </CCol>

              <CCol col="12" sm="6">
                <div class="d-flex align-items-center">
                  <label for="cookies_notification" class="mb-0 mr-1">
                    Ativar alerta de uso de cookies
                  </label>
                  <CSwitch
                    id="cookies_notification"
                    class="mx-1"
                    color="success"
                    variant="3d"
                    v-bind="labelIcon"
                    :checked="form.cookies_notification === '1' ? true : false"
                    @update:checked="setCookiesNotification($event)"
                  />
                </div>
              </CCol>
            </CRow>

            <!-- Layout -->
            <CRow
              v-if="
                form.cookies_notification !== '0' && form.cookies_notification
              "
              class="mb-5"
            >
              <CCol col="12">
                <h5>
                  <b>Posição</b>
                </h5>

                <p>
                  Determine a localização no site que você gostaria de exibir o
                  aviso:
                </p>

                <div class="preview-select">
                  <div
                    v-for="(item, index) in positions"
                    :key="item[index]"
                    v-c-tooltip="{
                      content: item.label,
                      placement: 'top',
                      appendToBody: true
                    }"
                    :class="{
                      active:
                        item.position == form.cookies_notification_position
                    }"
                    @click="selectPosition(item.position)"
                  >
                    <img
                      :src="
                        require(`@/assets/img/positions/${item.position}.png`)
                      "
                      :alt="`Posição ${item.label}`"
                    />
                  </div>
                </div>
              </CCol>
            </CRow>

            <!-- Controller -->
            <CRow
              v-if="
                form.cookies_notification !== '0' && form.cookies_notification
              "
              class="mb-5"
            >
              <CCol col="12">
                <h5>
                  <b>Controlador</b>
                </h5>

                <p>
                  Determine a localização no site que você gostaria de exibir o
                  controlador após os cookies serem aceitos:
                </p>

                <div class="preview-select">
                  <div
                    v-for="(item, index) in controllers"
                    :key="item[index]"
                    v-c-tooltip="{
                      content: item.label,
                      placement: 'top',
                      appendToBody: true
                    }"
                    :class="{
                      active:
                        item.position === form.cookies_notification_controller
                    }"
                    @click="selectController(item.position)"
                  >
                    <img
                      :src="
                        require(`@/assets/img/controllers/${item.position}.png`)
                      "
                      :alt="`Controlador ${item.label}`"
                    />
                  </div>
                </div>
              </CCol>
            </CRow>

            <!-- Type -->
            <CRow
              v-if="
                form.cookies_notification !== '0' && form.cookies_notification
              "
              class="mt-5"
            >
              <CCol col="12">
                <h5 class="mb-4">
                  <b>Tipo de aviso</b>
                </h5>

                <div class="custom-control custom-radio mb-2">
                  <input
                    id="customRadioInline1"
                    v-model="form.cookies_notification_version"
                    value="simple"
                    type="radio"
                    name="customRadioInline1"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="customRadioInline1">
                    Versão simples
                  </label>
                  <small style="margin-left: 10px" class="span_description">
                    (Exibir apenas a notificação de utilização dos cookies, mas
                    <b>NÃO</b> permite o controle dos cookies utilizados.)
                  </small>
                </div>

                <div class="custom-control custom-radio">
                  <input
                    id="customRadioInline2"
                    v-model="form.cookies_notification_version"
                    value="complete"
                    type="radio"
                    name="customRadioInline1"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="customRadioInline2">
                    Versão completa
                  </label>
                  <small style="margin-left: 10px" class="span_description">
                    (Exibir a notificação de utilização dos cookies e permite a
                    personalização do controle dos cookies utilizados.)
                  </small>
                </div>

                <div
                  v-if="form.cookies_notification_version === 'complete'"
                  class="form-group mt-4"
                >
                  <CAlert color="warning" class="ml-1 mt-2">
                    Para cadastrar os cookies utilizados no site acesse a página
                    de
                    <a href="/cookies" target="_blank" class="text-info"
                      ><b>Cookies.</b></a
                    >
                  </CAlert>
                </div>
              </CCol>
            </CRow>
          </CCol>

          <CCol
            v-if="
              form.cookies_notification !== '0' && form.cookies_notification
            "
            col="12"
            lg="4"
            xl="4"
            class="d-none d-lg-block"
          >
            <div>
              <h5>
                <b>Preview</b>
              </h5>

              <div class="preview-image">
                <img
                  :src="require(`@/assets/img/${selectedImg}.svg`)"
                  alt="Preview cookie position"
                />
              </div>
            </div>
          </CCol>
        </CRow>
      </CTab>

      <!-- PT/BR -->
      <CTab>
        <template slot="title"> Mensagem de Notificação - Português </template>

        <CRow
          v-if="form.cookies_notification !== '0' && form.cookies_notification"
          class="my-4 justify-content-between"
        >
          <CCol col="12">
            <div class="form-group">
              <label for="cookies-notification">
                Mensagem da utilização dos cookies no navegador
              </label>

              <TextEditor
                id="cookies-notification"
                v-model="form.cookies_notification_text"
                type="simpletext"
              />

              <small class="span_description">
                Texto que será exibido quando o usuário acessar o site pela
                primeira vez. Caso este campo esteja vazio será exibido um texto
                padrão no site.
              </small>
            </div>
          </CCol>
        </CRow>
      </CTab>

      <!-- EN -->
      <CTab>
        <template slot="title"> Mensagem de Notificação - Inglês </template>

        <CRow
          v-if="form.cookies_notification !== '0' && form.cookies_notification"
          class="my-4 justify-content-between"
        >
          <CCol col="12">
            <div class="form-group">
              <label for="cookies-notification-en">
                Mensagem da utilização dos cookies no navegador em inglês
              </label>

              <TextEditor
                id="cookies-notification-en"
                v-model="form.cookies_notification_text_en"
                type="simpletext"
              />

              <small class="span_description">
                Texto que será exibido quando o usuário acessar o site pela
                primeira vez em inglês. Caso este campo esteja vazio será
                exibido um texto padrão no site.
              </small>
            </div>
          </CCol>
        </CRow>
      </CTab>

      <!-- ES -->
      <CTab>
        <template slot="title"> Mensagem de Notificação - Espanhol </template>
        <CRow
          v-if="form.cookies_notification !== '0' && form.cookies_notification"
          class="my-4 justify-content-between"
        >
          <CCol col="12">
            <div class="form-group">
              <label for="cookies-notification-es">
                Mensagem da utilização dos cookies no navegador em espanhol
              </label>

              <TextEditor
                id="cookies-notification-es"
                v-model="form.cookies_notification_text_es"
                type="simpletext"
              />

              <small class="span_description"
                >Texto que será exibido quando o usuário acessar o site pela
                primeira vez em espanhol. Caso este campo esteja vazio será
                exibido um texto padrão no site.</small
              >
            </div>
          </CCol>
        </CRow>
      </CTab>
    </CTabs>

    <!-- Actions -->
    <CRow v-if="activeTabIndex !== cmsTabIndex">
      <CCol lg="12" class="d-flex justify-content-end align-items-center mt-2">
        <a href="javascript:void(0)" class="mr-3" @click="resetForm"
          >Limpar Alterações</a
        >
        <CButton color="success" :disabled="processing" @click="send">
          {{ processing ? 'Salvando...' : 'Salvar' }}
        </CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import TextEditor from '@/components/ui/TextEditor'
import { cloneDeep } from 'lodash'
import SettingsService from '@/services/settings.service'

export default {
  components: {
    TextEditor
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      settings: {
        // Cookies
        cookies_notification: true,
        cookies_notification_text: '',
        cookies_notification_text_en: '',
        cookies_notification_text_es: '',
        cookies_notification_position: 'left',
        cookies_notification_controller: 'none',
        cookies_notification_json: {}
      },
      form: {},
      processing: false,
      positions: [
        {
          position: 'left',
          label: 'Esquerda'
        },
        // {
        //   position: 'right',
        //   label: 'Direita'
        // },
        // {
        //   position: 'center',
        //   label: 'Centro'
        // },
        {
          position: 'top',
          label: 'Topo'
        },
        {
          position: 'bottom',
          label: 'Embaixo'
        }
      ],
      controllers: [
        {
          position: 'none',
          label: 'Sem controlador'
        },
        {
          position: 'left',
          label: 'Esquerda'
        }
        // {
        //   position: 'right',
        //   label: 'Direita'
        // }
      ],
      selectedImg: 'positions/previews/left',
      activeTabIndex: 0,
      cmsTabIndex: 7
    }
  },

  created() {
    this.handlerWindowSize()
    this.getSettings()
  },

  methods: {
    selectPosition(position) {
      this.selectedImg = `positions/previews/${position}`
      this.form.cookies_notification_position = position
    },

    selectController(position) {
      this.selectedImg = `controllers/previews/${position}`
      this.form.cookies_notification_controller = position
    },

    setCookiesNotification(checked) {
      this.form.cookies_notification = checked

      if (
        this.form.cookies_notification &&
        this.form.cookies_notification_text === ''
      ) {
        this.setDefaultCookiesNotificationText()
      }
    },

    setDefaultCookiesNotificationText() {
      this.form.cookies_notification_text =
        'Nós usamos cookies e outras tecnologias semelhantes para melhorar a sua experiência em nossos serviços. Ao utilizar nossos serviços, você concorda com tal monitoramento.'
    },

    async getSettings() {
      const data = await SettingsService.listAll()

      this.form = { ...this.settings, ...data }
      this.settings = cloneDeep(this.form)

      if (this.form.cookies_notification_position) {
        this.selectPosition(this.form.cookies_notification_position)
      }
    },

    resetForm() {
      this.form = cloneDeep(this.settings)
    },

    async send() {
      this.processing = true

      if (this.form.cookies_notification_text === '') {
        this.setDefaultCookiesNotificationText()
      }

      const data = this.form

      const response = await SettingsService.setSettings(data)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Configurações salvas com sucesso'
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Erro ao salvar as configurações, tente novamente mais tarde.'
        })
      }

      this.processing = false
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    /**
     * Verify and sets alignment of tabs component
     */
    handlerWindowSize() {
      const handler = () => {
        if (window.innerWidth <= 992) {
          this.variant = 'pills'
        } else {
          this.variant = 'tabs'
        }
      }

      window.addEventListener('resize', () => {
        handler()
      })

      handler()
    }
  }
}
</script>

<style lang="scss">
.website-tabs {
  .nav {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;

    .nav-item {
      a {
        white-space: nowrap;
      }
    }
  }
}

.informative {
  display: block;
  margin-top: 10px;
  padding: 15px 20px;
  background: #e1f3f8;
  border-radius: 0.25rem;
}

.span_description {
  color: #768192;
  margin-top: 0.25rem;
}

.preview-image {
  transform: translateX(-4%);

  img {
    width: 100%;
  }
}

.preview-select {
  display: flex;

  div {
    margin: 0px 10px;
    cursor: pointer;

    &:first-child {
      margin-left: 0px;
    }

    &:last-child {
      margin-right: 0px;
    }

    img {
      border: 2px solid $secondary-600;
    }

    &.active {
      img {
        border-color: $success;
      }
    }
  }
}
</style>
